export enum LoginAction {
  LOGIN, CHANGE_PASSWORD, RECOVERY_PASSWORD, MESSAGE
}
